import { render, staticRenderFns } from "./relSucursales.vue?vue&type=template&id=0fabc407&"
import script from "./relSucursales.vue?vue&type=script&lang=js&"
export * from "./relSucursales.vue?vue&type=script&lang=js&"
import style0 from "./relSucursales.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fabc407')) {
      api.createRecord('0fabc407', component.options)
    } else {
      api.reload('0fabc407', component.options)
    }
    module.hot.accept("./relSucursales.vue?vue&type=template&id=0fabc407&", function () {
      api.rerender('0fabc407', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/perfilEmpresa/relSucursales.vue"
export default component.exports